import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/stadium_estimate";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async check(params: any) {
    return api.check(params);
  }
  @Action
  async edit(params: any) {
    return api.edit(params);
  }
  @Action
  async submit(params: any) {
    return api.submit(params);
  }
}
